module.exports = __webpack_public_path__ + "fbe80608daa4b9cd669a72291c717967.png";